import { DataMap } from '@grapecity/wijmo.grid'

import { ListItem } from '../utility/list-item'

// NOTE: Make sure this stays in sync with the server-side enum (PendingChangeOrderInitiatedBy.cs).
export enum PendingChangeOrderInitiatedBy {
    Owner = 0,
    Engineer = 1,
    Vancon = 2,
    SupplierSub = 3,
}

const labels: Record<PendingChangeOrderInitiatedBy, string> = {
    [PendingChangeOrderInitiatedBy.Owner]: 'Owner',
    [PendingChangeOrderInitiatedBy.Engineer]: 'Engineer',
    [PendingChangeOrderInitiatedBy.Vancon]: 'Vancon',
    [PendingChangeOrderInitiatedBy.SupplierSub]: 'Supplier/Sub',
}

export function pendingChangeOrderInitiatedByDisplay(value: PendingChangeOrderInitiatedBy | undefined): string {
    const v = value ?? PendingChangeOrderInitiatedBy.Owner
    return labels[v] ?? labels[PendingChangeOrderInitiatedBy.Owner]
}

/** List items for Wijmo combo boxes (value = enum, display = label). Order matches the enum values 0..n. */
export function createPendingChangeOrderInitiatedByListItems(): ListItem<PendingChangeOrderInitiatedBy>[] {
    return [
        new ListItem<PendingChangeOrderInitiatedBy>(
            PendingChangeOrderInitiatedBy.Owner,
            labels[PendingChangeOrderInitiatedBy.Owner],
        ),
        new ListItem<PendingChangeOrderInitiatedBy>(
            PendingChangeOrderInitiatedBy.Engineer,
            labels[PendingChangeOrderInitiatedBy.Engineer],
        ),
        new ListItem<PendingChangeOrderInitiatedBy>(
            PendingChangeOrderInitiatedBy.Vancon,
            labels[PendingChangeOrderInitiatedBy.Vancon],
        ),
        new ListItem<PendingChangeOrderInitiatedBy>(
            PendingChangeOrderInitiatedBy.SupplierSub,
            labels[PendingChangeOrderInitiatedBy.SupplierSub],
        ),
    ]
}

/** Maps AI extraction output (e.g. ""Owner"") to the enum; returns undefined if unrecognized. */
export function parsePendingChangeOrderInitiatedByFromExtraction(
    text: string | null | undefined,
): PendingChangeOrderInitiatedBy | undefined {
    if (text == null || String(text).trim() === '') return undefined
    const normalized = String(text).trim().toLowerCase()
    for (const item of createPendingChangeOrderInitiatedByListItems()) {
        if (item.display?.toLowerCase() === normalized) return item.value
    }
    const byEnumName: Record<string, PendingChangeOrderInitiatedBy> = {
        owner: PendingChangeOrderInitiatedBy.Owner,
        engineer: PendingChangeOrderInitiatedBy.Engineer,
        vancon: PendingChangeOrderInitiatedBy.Vancon,
        suppliersub: PendingChangeOrderInitiatedBy.SupplierSub,
        'supplier/sub': PendingChangeOrderInitiatedBy.SupplierSub,
        supplier_sub: PendingChangeOrderInitiatedBy.SupplierSub,
    }
    return byEnumName[normalized]
}

/** DataMap for Wijmo grids (same key/display pairing as @see createPendingChangeOrderInitiatedByListItems). */
export function createPendingChangeOrderInitiatedByDataMap(): DataMap {
    return new DataMap(createPendingChangeOrderInitiatedByListItems(), 'value', 'display')
}
